const footercontent = {
  business: "Concierge Wellness",
  address1: "324 E Pikes Peak Ave, Ste 100",
  address2: "Colorado Springs, Colorado 80903",
  phone: "719-247-2207",
  email: "christian@conciergewellnessandpt.com",
  insta: "https://www.instagram.com/concierge_wellness/",
};

export default footercontent;
